import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App.tsx';
import { applyTheme, getStoredTheme } from './lib/theme';

// Apply saved chrome theme before first render to avoid a flash of the wrong colors.
applyTheme(getStoredTheme());

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;
const IS_DEV = import.meta.env.DEV;

const root = createRoot(document.getElementById('root')!);

if (PUBLISHABLE_KEY && !IS_DEV) {
  root.render(
    <StrictMode>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <App />
      </ClerkProvider>
    </StrictMode>,
  );
} else {
  // Dev mode: no Clerk key configured — render app without auth gate
  root.render(
    <StrictMode>
      <App authDisabled />
    </StrictMode>,
  );
}
